
const baseList = [
{
url: '/doctorList',
img: require('../../assets/banner/banner1@3x.png'),
}, {
url: '/doctorList',
img: require('../../assets/banner/banner2@3x.png'),
}, {
url: '/doctorList',
img: require('../../assets/banner/banner3@3x.png'), // 404

}



]
import common from "../../api/common";
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

export default {
components: {
Swiper,
SwiperItem
},
data() {
return {
cities : ["上海","北京","广州","重庆","西安"],
searchData:'',
arr : [],
searchhistory:[],//搜索历史
datalist:[],
sun:"",
discount:0,
kfc:"",
lock:1,
docid:'',
pay: true,
inquirypeople:this.$store.state.inquirypeople,
patientid: this.$store.state.userInfo.id,
addressTitle:[],
page:1,             //页码
pagination:1,//请求数据
heightof:"-90",
message: '暂无医生',
displayshow: true,
skillData: [],
noDataText: '',
total: 0,
skillname: '',
doctorname: '',
type: '',
demo01_index: 0,
demo01_list: baseList,
demo03_list: baseList,

}
},

methods: {
demo01_onIndexChange (index) {
this.demo01_index = index
},
checkedBox(i) {
if(this.arr.indexOf(i)!=-1){
this.arr.splice(this.arr.indexOf(i),1);
} else {
this.arr.push(i);
}
},
gotoImg(url){
this.$router.push({path:url});
},
query(){
this.getHotSearch();
this.searchhistory=JSON.parse(localStorage.getItem("searchhistory"))?JSON.parse(localStorage.getItem("searchhistory")):[];

},
gotokfc(){
this.$store.state.sun.pd = 1;
this.$router.push({path:'/myCoupon',query:{fromType: 'buy'}});
},
gotoinquiry(){
this.$router.push({path:'/inquirypeople',query:{selectType: '1'}});
},
more(){
this.$router.push({path:'/department'});
},
myDoctor(){
this.$router.push({path:'/physicianVisits'});
},
queryDoctor(){
this.$refs.inputs.blur();
if(this.doctorname!=''){
var searchhistory=JSON.parse(localStorage.getItem("searchhistory"))!=null?JSON.parse(localStorage.getItem("searchhistory")):[];
searchhistory.unshift(this.doctorname);
this.searchhistory=Array.from(new Set(searchhistory));
if(this.searchhistory.length>15){
this.searchhistory.splice(15,1);
}
localStorage.removeItem("searchhistory");
localStorage.setItem("searchhistory", JSON.stringify(this.searchhistory));
this.$store.state.doctorSearch=this.doctorname;
this.$router.push({path:'/doctorList'});
}else{
this.$router.go(-1);
}
this.searchhistory=JSON.parse(localStorage.getItem("searchhistory"))?JSON.parse(localStorage.getItem("searchhistory")):[];


},
goDepartment(e){
this.$store.state.doctorSearch=e;
this.$router.push({path:'/doctorList'});
},
clearHistory(){
localStorage.removeItem("searchhistory");
this.searchhistory=[];
},
querySkill(){
this.$doRequest('/api/doctorConfirmRest/goodAtList?type=2',null,res=>{
this.skillData = res.parameters;
})
},
itemClick(id){
this.$store.state.AllOfValue.doctorId = id;
this.$router.push({ path: "/doctorDetails", query: { state: 'g8t7r3'} });
},
searchopen(){
this.searchhistory=JSON.parse(localStorage.getItem("searchhistory"))?JSON.parse(localStorage.getItem("searchhistory")):[];
},
getHotSearch(){
this.$doRequest('/api/hotSearch/getHotSearchList',{},res=>{
this.searchData = res.parameters;
})
}
},

created() {
document.title = '找名医';
var _this=this;

this.$isLogin(window.location.search.substr(1), _this.query);


}
}



// WEBPACK FOOTER //
// ./src/views/doctorSeek/index.vue